<div class="card" *blockUI="'section-block'">

  <div class="row col-12 d-flex justify-content-between mt-1 mb-1">
    <!-- Left-aligned "Kategori Ekle" button -->
    <div>
      <button class="btn btn-primary ml-1" rippleEffect (click)="toggleSidebar('create-category', null)" *ngIf="authService.isEndpointStatus('POST.Writing.CreateCategory')">
        <i data-feather="plus" class="d-sm-none d-inline-block"></i>
        <span class="d-none d-sm-inline-block">Kategori Ekle</span>
      </button>
    </div>
  
    <!-- Right-aligned dropdown and search input -->
    <div class="d-flex align-items-center">
      <!-- Page size dropdown -->
      <label class="d-flex align-items-center mr-2">
        <select class="form-control mx-25" [(ngModel)]="basicSelectedOption" (ngModelChange)="onOptionChange()">
          <option value="5">5</option>
          <option value="10">10</option>
          <option value="15">15</option>
          <option value="50">50</option>
        </select>
      </label>
  
      <!-- Search input -->
      <label class="d-flex align-items-center">
        <input type="search" placeholder="Bul" class="form-control ml-25" (keyup)="filterUpdate($event)" (search)="filterUpdate($event)" />
      </label>
    </div>
  </div>
  
  <ngx-datatable [rows]="rows" [rowHeight]="50" class="bootstrap core-bootstrap" style="cursor: pointer;" [messages]="{ 
    emptyMessage: 'Veri Yok',
    totalMessage: 'Toplam', 
    selectedMessage: 'Seçili'
  }" [limit]="selectedSize" [columnMode]="ColumnMode.force" [headerHeight]="50" [footerHeight]="50"
    [scrollbarH]="true">

    <ngx-datatable-column name="Kategori Adı" prop="categoryName"></ngx-datatable-column>
    <ngx-datatable-column name="Kategori Türü" prop="kindName"></ngx-datatable-column>


    <ngx-datatable-column name="#" [sortable]="false">
      <ng-template let-row="row" ngx-datatable-cell-template>
        <div class="d-flex align-items-center">
          <button type="button" class="btn btn-icon btn-icon rounded-circle btn-flat-success" rippleEffect *ngIf="authService.isEndpointStatus('PUT.Updateing.UpdateCategory')"
            (click)="toggleSidebar('create-category',row)">
            <span [data-feather]="'edit'"></span>
          </button>

          <button appDelete controller="categories" [id]="row.id" (callback)="sendEvent()" type="button" *ngIf="authService.isEndpointStatus('DELETE.Deleteing.RemoveCategory')"
            class="btn btn-icon btn-icon rounded-circle btn-flat-danger" rippleEffect>
            <span [data-feather]="'trash'"></span>
          </button>
        </div>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-footer>
      <ng-template ngx-datatable-footer-template>
        <div class="datatable-footer-inner">
          <div class="page-count">
            Toplam Veri {{ totalCount }}
          </div>
          <ngb-pagination [collectionSize]="(totalCount / basicSelectedOption) * 10" [(page)]="pageBasic"
            (pageChange)="onPageChange($event)" [maxSize]="5"> 
            <ng-template ngbPaginationPrevious>
              <span [data-feather]="'chevron-left'" [size]="18" [class]="'font-weight-bolder'"></span>
            </ng-template>
            <ng-template ngbPaginationNext>
              <span [data-feather]="'chevron-right'" [size]="18" [class]="'font-weight-bolder'"></span>
            </ng-template>
          </ngb-pagination>
        </div>
      </ng-template>
    </ngx-datatable-footer>
  </ngx-datatable>
  <core-sidebar class="modal modal-slide-in sidebar-todo-modal fade" name="create-category"
    overlayClass="modal-backdrop">
    <app-create-category [category]="selectedCategory"></app-create-category>
  </core-sidebar>
</div>